// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__8k+FZ","wave":"Loading_wave__OmbGg","miniWave":"Loading_miniWave__HJKUE","spWaveBe":"Loading_spWaveBe__c6-H4","spWaveAf":"Loading_spWaveAf__D4-tR"};